"use strict";

const KTApp = require("../../components/app");
const EventListener = require("./event-listener");
const { getTreeviewSubSectionItems, preventCloseOnClickInsideDropdown, getScrollSizeForPopper } = require("./helpers");
const QBreadcrumbQuickAccess = require("./q-breadcrumb-quick-access");
const QFavoriteButton = require("./q-favorite-button");
const { effect } = require('@node_modules/@preact/signals-core');

class QBreadcrumbMenu {
    constructor(elementId, config) {
        this._element = $(`#${elementId}`);
        this._quantidaItemsMenu = 17;
        this._userName = config.userName;
        this._menuConfig = config.menuConfig;
        this._template = config.template;
        this._homeRoute = config.homeRoute;
        this._lazy = config.lazyLoad;
        this._keyLocalStorage = 'BREADCRUMB_SUBSECTION_FILTER';
        this._useTitleConfig = config.useTitle;
        this._ignoreActiveItem = config.ignoreActiveItem;

        this._initEventListeners();

        this._element.append(this._build());
    }

    _build() {
        var configActive = this._ignoreActiveItem ? null : this._menuConfig.sections.find((el) => {
            return !el.isCompany && el.isActive
        });

        if (!configActive) {
            return this._createUserAndDate();
        }
        else {
            const quickAccessEl = QBreadcrumbQuickAccess(this._menuConfig.sections, {
                dispatchEvent: this._dispatchEvent.bind(this),
                on: this.on.bind(this)
            });

            this._element.append(this._createHomeItem(this._homeRoute), quickAccessEl);
        }

        this._createSection(configActive);
    }

    _createUserAndDate() {
        moment.locale('pt-br');
        var weekDay = moment().format('dddd');
        var extensiveDate = moment().format('LL');

        return `<li class='breadcrumb-item'
                    <a class="font-size-h3">${this._userName}, ${weekDay}, ${extensiveDate}</a>
                </li>`;
    }


    _itemTemplate(item, options = {}) {
        const useIcon = typeof options.useIcon != 'undefined' ? options.useIcon : true;
        const itemEl = $(/*html*/ `
            <li class="navi-item">
                <a class="navi-link${item.isActive ? ' active' : ''} h-100" href="${item.href}">
                    <span class="navi-icon">
                        ${useIcon ? /*html*/`<i class="las ${item.icon ? item.icon : 'la-folder-open icon-default'} text-primary"></i>` : ''}
                    </span>
                    <span class="navi-text">${item.caption}</span>
                    <span class="navi-label"></span>
                </a>
            </li>
        `);

        itemEl
            .find('.navi-label')
            .append(QFavoriteButton({ 
                item: item,
                onClick: (event) => {
                    this._dispatchEvent({
                        type: 'favorite-click',
                        originalEvent: event,
                        item: item,
                        isFavorite: $(event.currentTarget).find('i').hasClass('la-star'), 
                    });
                },
            }));

        if ((options || {}).useTooltip) {
            itemEl
                .find('a.navi-link')
                .tooltip({
                    placement: 'bottom',
                    title: item.path,
                    container: itemEl
                });
        }

        return itemEl;
    }

    _buildShowMoreButton(useIcon = true) {
        const item = this._itemTemplate(
            {
                href: '',
                icon: 'la-ellipsis-h',
                caption: 'VER TODOS'
            },
            {
                useIcon: useIcon,
            }
        );

        item.find('.navi-label').remove();

        return item
            .addClass('show-more-items')
            .on('click', (event) => {
                event.preventDefault();

                item
                    .closest('.card')
                    .addClass('show-all')
                    .removeClass('show-limited');
            });
    }

    _createHomeItem(homeRoute) {
        return $(`<li class='breadcrumb-item'>
                    <a href="${homeRoute}"><i class="la la-home icon-lg text-dark"></i></a>
                </li>`);
    }

    _createSection(configActive) {
        if (configActive.items) {
            var subSectionActive = configActive.items.find((el) => {
                return el.isActive;
            });

            if (subSectionActive.items) {
                this._createSectionDropdown(configActive);
            }

            this._createSubSection(subSectionActive.items ? subSectionActive : configActive, Boolean(subSectionActive.items));
        }
        else {
            this._element.append($(
                `<li class="breadcrumb-item">
                    <a>${configActive.caption}</a>
                </li>`
            ));
        }
    }

    _createSectionDropdown(configActive) {
        const breadCrumbItem = this._createBreadCrumbItem(configActive.caption);
        const sections = this._menuConfig.sections.filter((section) => !section.isCompany && !section.isProduct && !section.isQuickAccess);
    
        breadCrumbItem.find('.dropdown-menu').append(this._createTabs(sections));
        preventCloseOnClickInsideDropdown(breadCrumbItem.find('.dropdown'));

        this._element.append(breadCrumbItem);
    }

    _createBreadCrumbItem(caption) {
        const item = $(/*html*/
            `<li class="breadcrumb-item">
                <div class="dropdown dropdown-inline">
                    <a class="btn btn-sm dropdown-toggle py-2 px-1 font-size-h3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">${caption}</a>
                    <div class="dropdown-menu dropdown-menu-left p-0" x-placement="bottom-end"></div>
                </div>
            </li>`
        );

        this._fixDropdownPositioning(item);

        return item;
    }

    _fixDropdownPositioning(item) {
        item
        .find('[data-toggle="dropdown"]')
        .data('popperConfig', {
            positionFixed: true,
            modifiers: {
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'viewport',
                },
                flip: {
                    enabled: false,
                },
                offset: {
                    enabled: true,
                    fn: (data) => {
                        const headerSize = KTLayoutHeader.getHeight() + KTLayoutSubheader.getHeight();
                        const offsets = data.offsets
                        const offsetTop = Math.ceil(offsets.reference.top + offsets.reference.height);
                        const top = offsetTop < headerSize ? headerSize : offsetTop;
                        const options = {
                            offsetTop: `${top}px`,
                            spacingBottom: '6px', // margin between dropdown and inferior toolbar
                            marginBottom: '52px' // inferior toolbar height
                        }
                        
                        data.styles = {
                            ...data.styles,
                            transform: `translate3d(${offsets.popper.left}px, ${top}px, 0px)`,
                            overflowY: 'hidden',
                        };

                        $('.custom-scrollbar', item).each((index, el) => {
                            const tab = $(el).closest('[role="tabpanel"]');

                            if (tab.length) {
                                const tabHeaderHeight = $(el)
                                    .closest('.tab-content')
                                    .siblings('[role="tablist"]')
                                    .outerHeight(true);

                                $(el).css(getScrollSizeForPopper({
                                    ...options,
                                    useMinHeight: true,
                                    sizes: [
                                        `${tabHeaderHeight}px`,
                                        tab.css('padding-top'),
                                        tab.css('padding-bottom')
                                    ]
                                }));
                            }
                            else {
                                const parent = $(el).parent();

                                $(el).css(getScrollSizeForPopper({
                                    ...options,
                                    sizes: [
                                        parent.css('padding-top'),
                                        parent.css('padding-bottom')
                                    ]
                                }));
                            }
                        });

                        return data;
                    }
                }
            },
        })
    }

    _createTabs(sections) {
        const tabHeader = this._createTabHeader(sections);
        const tabBody = this._createTabsBody(sections);

        return [tabHeader, tabBody];
    }

    _createTabHeader(sections) {
        const tabHeader = $(/*html*/`<ul  class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x mt-3 px-4" role="tablist">`);
        
        tabHeader.append(sections.map((section) => this._createTabLink(section, section.isActive)));

        return tabHeader;
    }

    _createTabLink(section, isActive) {
        return $(/*html*/
            `<li class="nav-item" style="">
                <a class="nav-link px-8 py-2 m-0 justify-content-center ${isActive ? 'show active' : ''}" data-toggle="tab" href="#tab_breadcrumb_${section._uuid}">
                    ${section.caption}
                </a>
            </li>`
        );
    }

    _createTabsBody(sections) {
        const tabWrapper = $('<div class="tab-content">');

        tabWrapper.append(sections.map((section) => this._createTabContent(section, section.isActive)));

        return tabWrapper;
    }

    _createTabContent(section, isActive) {
        const hasSubSection = section.items.find((subSectionOrMenu) => subSectionOrMenu.items);
        const tabContent = $(/*html*/`<div class="tab-pane bg-white pt-8 pb-4 px-4 ${isActive ? 'active' : ''}" id="tab_breadcrumb_${section._uuid}" role="tabpanel">`);
        const scrollContent = $(/*html*/`<div class="navi custom-scrollbar p-0 teste">`).css({
            'max-height': '520px',
            'min-height': '150px',
            'overflow-y': 'auto',
            'word-break': 'break-word',
            'display': 'grid',
            'grid-template-columns': 'repeat(2, minmax(auto, 1fr))',
            'grid-auto-rows': 'max-content'
        });

        if (hasSubSection) {
            const elements = [];
            let index = 0;

            const appendToGroup = (el, i) => {
                if (!elements[i]) {
                    elements[i] = $('<div>');
                }

                elements[i].append(el);
            }
            section.items.forEach((subSection) => {
                if (subSection.title) {
                    const titleEl = $(/*html*/`
                        <div class="navi-section p-0 m-0 w-100"> 
                            <div class="d-flex py-3 pr-4 pl-2 align-items-center">
                                <span class="navi-text font-size-h1 mb-0 text-primary">
                                    ${subSection.title}
                                </span>
                            </span>
                        </div>
                    `).css('grid-column-start', 'span 3');

                    appendToGroup(titleEl, ++index);
                }

                if (subSection.items) {
                    const subSectionEl = $(/*html*/
                        `<div class="navi-item h-auto">
                            <a href="${this._homeRoute}" class="navi-link px-4 py-0 h-100 ${subSection.isActive ? 'active' : ''}">
                                <span class="navi-text flex-grow-0 text-line-clamp font-size-h3">${subSection.caption}</span>
                            </a>
                        </div>`
                    )
                        .css('width', 'fit-content')
                        .on('click', (event) => {
                            const title = this._useTitleConfig ? (section.items.slice(0, section.items.indexOf(subSection) + 1).toReversed().find(item => item.title) || {}).title : null;
                            const path = `${section.caption}__${title ? `${title}__` : ''}${subSection.caption}`;

                            localStorage.setItem(this._keyLocalStorage, path);
                        });

                    appendToGroup(subSectionEl, index);
                }
                else {
                    appendToGroup(this._itemTemplate(subSection), index);
                }
            });

            scrollContent.append(elements);
            tabContent.append(scrollContent);
        }
        else {
            const div = $(/*html*/`<div class="card card-custom show-limited box-shadow-none"><div class="card-body p-0"></div></div>`);
    
            this._createDropdownItemsMenu(section, scrollContent);
    
            div.find('.card-body').append(scrollContent);
    
            tabContent.append(div);
        }

        return tabContent;        
    }

    _createSubSection(subSectionActive, isSubSection) {
        const menuItems = subSectionActive.withTreeview ? getTreeviewSubSectionItems(subSectionActive.items) : subSectionActive.items; 

        if (menuItems && menuItems.length > 1) {
            let menuItemActive;
            
            if (isSubSection) {
                const hasCategory =  Boolean(!subSectionActive.withTreeview && subSectionActive.items.find((item) => item.items)); 
                const html = this._createBreadCrumbItem(subSectionActive.caption);

                if (hasCategory) {
                    html
                        .find('.dropdown-menu')
                        .append(this._createCategoryTabs(subSectionActive));

                    preventCloseOnClickInsideDropdown(html.find('.dropdown'));

                    for (let category of subSectionActive.items) {
                        if (menuItemActive = category.items.find((menuItem) => menuItem.isActive)) break;
                    }
                }
                else {
                   const dropdownContent = $(/*html*/
                        `<div class="card card-custom show-limited">
                            <div class="card-body p-4">
                                <div class="navi custom-scrollbar"></div>
                            </div>
                        </div>`
                    );

                    menuItemActive = menuItems.find(item => item.isActive);

                    html
                        .find('.dropdown-menu')
                        .append(dropdownContent);
    
                    this._createDropdownItemsMenu(subSectionActive, dropdownContent.find('.navi'));
                }

                this._element.append(html);
                
                this._createMenuItem(menuItemActive);
            }
            else {
                menuItemActive = menuItems.find((el) => el.isActive);

                this._createSectionDropdown(subSectionActive);

                this._createMenuItem(menuItemActive);
            }

            this._element
                .closest('.subheader')
                .append(this._createBreadcrumbFavoriteButton(menuItemActive));

            return;
        }

        this._createMenuItem(subSectionActive);

        if (menuItems && menuItems.length == 1) {
            const menuItem = menuItems[0];

            this._createMenuItem(menuItem);

            this._element
                    .closest('.subheader')
                    .append(this._createBreadcrumbFavoriteButton(menuItem));
        }
    }

    _createMenuItem(menuItem) {
        this._element.append($(`<li class="breadcrumb-item">
                                    <a class="btn-sm font-size-h3">${menuItem.caption}</a>
                                </li>`));
    }

    _createBreadcrumbFavoriteButton(menuItem) {
        let firstExecution = true;
        const getTooltipText = (isFavorite) => `Clique para ${isFavorite ? 'remover' : 'adicionar'} a página ${isFavorite ? 'd': 'a'}os favoritos.`;
        const favoriteButtonWrapper = $(/*html*/
            `<div class="kt-subheader__toolbar">
                <div class="kt-subheader__wrapper">
                    <button 
                        data-toggle="popover"
                        data-content="${getTooltipText(menuItem.isFavorite)}" 
                        class="favorite-page btn kt-subheader__btn-favorite btn-icon favorite-button"
                        data-original-title=""
                        title=""
                        data-id="favorite_button_${menuItem._uuid}"
                    >
                        <i class="la la-star${menuItem.isFavorite ? '' : '-o'}"></i>
                    </button>
                </div>
            </div>`
        );
        const favoriteButtonEl = favoriteButtonWrapper.find('button');

        const dispose = effect(() => {
            if (!firstExecution && !document.contains(favoriteButtonWrapper.get(0))) {
                dispose();
                return;
            }

            const isFavorite = menuItem._isFavorite.value;
            
            firstExecution = false;

            favoriteButtonWrapper
                .find('i')
                .toggleClass('la-star-o', !isFavorite)
                .toggleClass('la-star', isFavorite);

            
            favoriteButtonEl.attr('data-content', getTooltipText(isFavorite));
        });

        favoriteButtonEl.on('click', (event) => {
            menuItem._isFavorite.value = !menuItem._isFavorite.peek();
            menuItem.isFavorite = menuItem._isFavorite.peek();

            this._dispatchEvent({
                type: 'favorite-click',
                originalEvent: event,
                item: menuItem,
                isFavorite: menuItem._isFavorite.peek(),
            });
        });

        KTApp.initPopover(favoriteButtonEl);

        return favoriteButtonWrapper;
    }

    _createDropdownItemsMenu(subSectionActive, html) {
        const buildShowLessButton = (items) => {
            const item = $(/*html*/
                `<div class="navi-item ${items.length < 17 ? 'd-none' : ''}">
                    <a href="#" class="navi-link h-100">
                        <span class="navi-icon"></span>
                        <span class="navi-text flex-grow-0 text-line-clamp text-primary"><b>ver menos</b></span>
                        <span class="navi-label ml-1 "><i class="las la-times text-primary"></i></span>
                    </a>
                </div>`
            );
        
            return item.on('click', (event) => {

                event.stopPropagation();

                item.closest('.card')
                    .removeClass('show-all')
                    .addClass('show-limited')
            });
        };
        const buildItem = (item) => {
            const itemEl = $(/*html*/
                `<div class="navi-item" data-item-id="${item._uuid}">
                    <a href="${item.href}" class="navi-link h-100 ${item.isActive ? 'active' : ''}">
                        <span class="navi-icon">
                            ${
                                item.icon 
                                    ? /*html*/`<i class="las ${item.icon}"></i>`
                                    : ''
                            }
                        </span>
                        <span class="navi-text flex-grow-0 text-line-clamp">${item.caption}</span>
                        <span class="navi-label"></span>
                    </a>
                </div>`
            );

            itemEl
                .find('.navi-label')
                .append(QFavoriteButton({
                    item: item,
                    onClick: (event) => {
                        this._dispatchEvent({
                            type: 'favorite-click',
                            originalEvent: event,
                            item: item,
                            isFavorite: $(event.currentTarget).find('i').hasClass('la-star'),
                        });
                    }
                }));

                return itemEl;
        };

        const items = subSectionActive.withTreeview ? getTreeviewSubSectionItems(subSectionActive.items) : subSectionActive.items; 
        const menuItems = (this._lazy ? items.slice(0, 18) : items).map((item) => buildItem(item));

        html.append(menuItems);

        const showLessButton = buildShowLessButton(menuItems);
        const showMoreButton = this._buildShowMoreButton(false);

        showMoreButton
            .on('click', (event) => {
                event.stopPropagation();
            })
            .find('.navi-text')
            .text('VER TODOS...')
            .addClass('text-primary');
        
        showMoreButton.find('.navi-icon');

        if (this._lazy) {
            const buildOnClick = () => {
                showLessButton.before(
                    items.slice(18).map((item) => buildItem(item))
                );

                showMoreButton.off('click', buildOnClick);
            }

            showMoreButton.on('click', buildOnClick);
        }
        

        html.append(showMoreButton, showLessButton);

        return html;
    }

    _createCategoryTabs(subSection) {
        const tabHeader = $(/*html*/`<ul class="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-3x mt-3 px-4" role="tablist">`);
        const tabBody = $('<div class="tab-content">');
        
        tabHeader.append(subSection.items.map((category) => this._createTabLink(category, category.isActive)));
        tabBody.append(subSection.items.map((category) => this._createCategoryTabContent(category)));

        return [tabHeader, tabBody];
    }

    _createCategoryTabContent(category) {
        const tabContent = $(/*html*/`<div class="tab-pane bg-white ${category.isActive ? 'show active' : ''}" id="tab_breadcrumb_${category._uuid}" role="tabpanel">`);
        const card = $(/*html*/`<div class="card card-custom show-limited"><div class="card-body pt-8 pb-4 px-4"></div></div>`);
        const scrollContent = $(/*html*/`<div class="navi custom-scrollbar p-0 teste">`).css({
            'max-height': '520px',
            'min-height': '150px',
            'overflow-y': 'auto',
            'word-break': 'break-word',
            'display': 'grid',
            'grid-template-columns': 'repeat(3, minmax(0, 1fr))',
            'grid-auto-rows': 'max-content'
        });

        card.find('.card-body').append(scrollContent);

        this._createDropdownItemsMenu(category, scrollContent);

        return tabContent.append(card);
    }

    _initEventListeners() {
        this._eventListener = {
            'favorite-click': new EventListener()
        }
    }

    _dispatchEvent(event) {
        if (this._eventListener[event.type]) {
            this._eventListener[event.type].dispatch(event);
        }
    }

    on(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].addEventListener(listener);
        }
    }

    off(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].removeEventListener(listener);
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = QBreadcrumbMenu;
}